import React, { useEffect, useRef, useState } from "react";
import Layout from "./Layout";
import bitmoji from "./assets/bitmoji.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "./index.css";
import { referralAttribution } from "./referralAttribution";
import logo from "./assets/Ryan Tutors Logo2.png";


function HomePage() {
  const [form, setForm] = useState({
    name: "",
    learner: "",
    email: "",
    subject: "",
    preferredTime: "",
    phone: "",
    message: "",
    relationship: "",
    schoolYear: "",
    customSchoolYear: "",
      additionalNeeds: "",
    website: "",
  });


  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const submittingRef = useRef(false);
const [hoveringSubmit, setHoveringSubmit] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
      // if the “School Year” select changes away from “Other”, clear the custom field
      ...(name === "schoolYear" && value !== "Other" && { customSchoolYear: "" }),
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return;
    submittingRef.current = true;
    setSubmitting(true);
    try {
      await referralAttribution.capture(window.location.search);
      const referralToken = await referralAttribution.submission();
      const response = await fetch("/api/enquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, referralToken })
      });
      const result = await response.json();
      if (!response.ok || !result.ok) throw new Error(result.error || "Failed to send enquiry.");
      setSubmitted(true);
      setForm({ name: "", learner: "", email: "", subject: "", preferredTime: "", phone: "",
        message: "", relationship: "", schoolYear: "", customSchoolYear: "", additionalNeeds: "", website: "" });
    } catch (error) {
      console.error("Enquiry could not be sent.");
      alert(error.message || "Failed to send enquiry. Please try again.");
    } finally {
      submittingRef.current = false;
      setSubmitting(false);
    }
  };

  const navigate = useNavigate();
  const { user, role } = useAuth();


  useEffect(() => {
    if (user && role === "tutor") {
      navigate("/tutor-dashboard");
    } else if (user && role === "student") {
      navigate("/student-dashboard");
    }
  }, [user, role, navigate]);


// ✅ Automatically generate next available Wed–Fri (7–9pm) and Sat/Sun (9–11am) 15-minute slots
// ✅ Generate slots and then sort them chronologically by the real start Date
function generateWeeklySlots() {
  const days = [
    { day: 3, start: 19, end: 21 }, // Wed 7–9pm
    { day: 4, start: 19, end: 21 }, // Thu 7–9pm
    { day: 5, start: 19, end: 21 }, // Fri 7–9pm
    { day: 6, start: 9, end: 11 },  // Sat 9–11am
    { day: 0, start: 9, end: 11 },  // Sun 9–11am
  ];


  const now = new Date();


  const dateFormatter = new Intl.DateTimeFormat("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });


  const slots = [];


  for (const { day, start, end } of days) {
    // days until the next occurrence of `day` (if today, use next week)
    const daysAhead = (day - now.getDay() + 7) % 7;
    const addDays = daysAhead === 0 ? 7 : daysAhead;


    const base = new Date(now);
    base.setDate(now.getDate() + addDays);
    base.setHours(start, 0, 0, 0);


    for (let h = start; h < end; h++) {
      for (let m = 0; m < 60; m += 15) {
        const slotStart = new Date(base);
        slotStart.setHours(h, m, 0, 0);


        const slotEnd = new Date(slotStart);
        slotEnd.setMinutes(slotEnd.getMinutes() + 15);


        const dateLabel = dateFormatter.format(slotStart).replace(",", "");
        const timeLabel = `${slotStart.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })} - ${slotEnd.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })}`;


        slots.push({
          start: slotStart.getTime(),          // sort key
          label: `${dateLabel} ${timeLabel}`,  // what you display/store
        });
      }
    }
  }


  // ✅ true chronological order
  slots.sort((a, b) => a.start - b.start);


  return slots.map((s) => s.label);
}






  return (
    <Layout>
      <div style={styles.wrapper}>
        <div style={styles.textSection}>
          <img src={logo} alt="Logo" className="mobile-logo" />
         <h1 style={styles.heading}>✨ Personalised Maths & French Tutoring</h1>
<p style={styles.subheading}>
  Hi, I'm Ryan – a friendly, experienced tutor helping learners build confidence, boost grades, and enjoy learning.
</p>
<p style={{ ...styles.subheading, fontStyle: "italic", color: "#666" }}>
  I offer one-to-one support in GCSE and A-Level Maths & French.
</p>
<p style={{ ...styles.subheading, marginTop: "1rem" }}>
  ✅ <strong>To book a free meet-the-tutor session</strong>, just fill out the form below and choose a time that works for you.
</p>
<p style={{ ...styles.subheading }}>
  📌 Want to know more about what I offer and pricing? Just click the <strong>About</strong> link at the top of the page.
</p>






          <div style={styles.formCard}>
            <img src={bitmoji} alt="Bitmoji" style={styles.bitmoji} />
            <h2>Book a Tutoring Session</h2>
            {submitted ? (
              <p style={{ color: "green" }}>✅ Thank you for your enquiry. I will be in touch.</p>
            ) : (
              <form onSubmit={handleSubmit} style={styles.form}>
                {/* Your Name */}
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  style={styles.input}
                />


                {/* Learner’s Name */}
                <input
                  type="text"
                  name="learner"
                  placeholder="Learner’s Name"
                  value={form.learner}
                  onChange={handleChange}
                  required
                  style={styles.input}
                />


                {/* Email Address */}
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={form.email}
                  onChange={handleChange}
                  required
                  style={styles.input}
                />


                {/* Phone Number */}
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={form.phone}
                  onChange={handleChange}
                  required
                  style={styles.input}
                />


                {/* Relationship to Learner */}
                <select
                  name="relationship"
                  value={form.relationship}
                  onChange={handleChange}
                  required
                  style={styles.input}
                >
                  <option value="">Relationship to Learner</option>
                  <option value="Mother">Mother</option>
                  <option value="Father">Father</option>
                  <option value="Grandparent">Grandparent</option>
                  <option value="Aunt">Aunt</option>
                  <option value="Uncle">Uncle</option>
                  <option value="Sister">Sister</option>
                  <option value="Brother">Brother</option>
                  <option value="Friend">Friend</option>
                  <option value="Myself (self-referral)">Myself (self-referral)</option>
                  <option value="Other">Other</option>
                </select>


                {/* School Year (2026/2027) */}
                <select
                  name="schoolYear"
                  value={form.schoolYear}
                  onChange={handleChange}
                  required
                  style={styles.input}
                >
                  <option value="">School Year (2026/2027)</option>
                  <option value="Year 6">Year 6</option>
                  <option value="Year 10">Year 10</option>
                  <option value="Year 11">Year 11</option>
                  <option value="Year 12">Year 12</option>
                  <option value="Year 13">Year 13</option>
                  <option value="Other">Other… (please state)</option>
                </select>


                {form.schoolYear === "Other" && (
                  <input
                    type="text"
                    name="customSchoolYear"
                    placeholder="Please specify school year"
                    value={form.customSchoolYear}
                    onChange={handleChange}
                    required
                    style={styles.input}
                  />
                )}

<textarea
  name="additionalNeeds"
  placeholder="Any additional learning needs or diagnoses? (e.g. dyslexia, dyscalculia, autism etc.)"
  value={form.additionalNeeds}
  onChange={handleChange}
  rows="3"
  style={styles.textarea}
/>

                {/* Subject */}
                <select
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  style={styles.input}
                >
                  <option value="">Select a Subject</option>
                  <option value="Primary Maths">Primary Maths</option>
                  <option value="GCSE Maths">GCSE Maths</option>
                  <option value="A-Level Maths">A-Level Maths</option>
                  <option value="Primary French">Primary French</option>
                  <option value="GCSE French">GCSE French</option>
                  <option value="A-Level French">A-Level French</option>
                </select>


                {/* Preferred Day/Time */}
                {/* Preferred Day/Time */}
<select
  name="preferredTime"
  value={form.preferredTime}
  onChange={handleChange}
  required
  style={styles.input}
>
  <option value="">Select a free meet-the-tutor slot</option>
  {generateWeeklySlots().map((slot, idx) => (
    <option key={idx} value={slot}>
      {slot}
    </option>
  ))}
</select>




                {/* Extra message */}
                <textarea
                  name="message"
                  placeholder="Anything else you'd like me to know?"
                  value={form.message}
                  onChange={handleChange}
                  rows="3"
                  style={styles.textarea}
                />


                <div aria-hidden="true" style={{ display: 'none' }}>
                  <label htmlFor="enquiry-website">Leave this empty</label>
                  <input id="enquiry-website" name="website" value={form.website} onChange={handleChange} tabIndex={-1} autoComplete="off" />
                </div>
               <button
  type="submit"
  disabled={submitting}
  style={{
    ...styles.submitBtn,
    ...(hoveringSubmit ? styles.submitBtnHover : {}),
  }}
  onMouseEnter={() => setHoveringSubmit(true)}
  onMouseLeave={() => setHoveringSubmit(false)}
>
  {submitting ? "Sending..." : "Submit Enquiry"}
</button>


              </form>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}


// (Styles remain unchanged)
const styles = {
wrapper: {
  display: "flex",
  justifyContent: "center",
  paddingTop: "2rem",
  paddingBottom: "4rem", // gives space below
  flexWrap: "wrap",      // allows content to wrap naturally
},


  textSection: {
    maxWidth: "600px",
    textAlign: "center",
  },
  heading: {
    fontSize: "2rem",
    fontWeight: "600",
    marginBottom: "0.3rem",
  },
  subheading: {
    fontSize: "1rem",
    color: "#444",
    marginBottom: "2rem",
  },
  formCard: {
    backgroundColor: "#f9f9f9",
    padding: "2rem",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
    textAlign: "left",
    position: "relative",
    overflow: "visible",
  },
  bitmoji: {
    width: "200px",
    position: "absolute",
    right: "-89px",
    top: "80%",
    zIndex: 2,
    filter: "drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.2))",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  input: {
    padding: "0.5rem",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "0.9rem",
  },
  textarea: {
    padding: "0.5rem",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "0.9rem",
    resize: "vertical",
  },
  submitBtn: {
  backgroundColor: "#28a745",
  color: "white",
  padding: "0.7rem",
  border: "none",
  borderRadius: "6px",
  fontWeight: "bold",
  fontSize: "1rem",
  cursor: "pointer",
  transition: "background-color 0.3s ease",
},


submitBtnHover: {
  backgroundColor: "#218838",
},
};


export default HomePage;



